/* eslint-disable */
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import ListItem from "@mui/material/ListItem";

import styles from "assets/jss/xrs/components/headerLinksStyle.js";

const useStyles = makeStyles()((theme) => styles(theme));

export default function HeaderLinks() {
  const { classes } = useStyles();
  return (
    <div>
      <ListItem className={classes.listItem}>
        <Link to="/landing-page" className={classes.dropdownLink}>
          Home
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/createUser" className={classes.dropdownLink}>
          Register
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/quickpay-page" className={classes.dropdownLink}>
          Quick Pay
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/faq-page" className={classes.dropdownLink}>
          Frequently Asked Questions
        </Link>
      </ListItem>
    </div>
  );
}

HeaderLinks.defaultProps = {
  hoverColor: "primary",
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
  ]),
};
